import { FunctionComponent } from 'react';
import styles from './PhotosSpecifications.module.scss';
import clsx from 'clsx';

interface PhotosSpecificationsProps {
    maxPhotos: number;
    className?: string;
}

export const PhotosSpecifications: FunctionComponent<PhotosSpecificationsProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <span className={styles.text}>Recommended Size: 980 x 1200 px JPG or PNG</span>
            <span className={styles.text}>{`Max ${props.maxPhotos} Photos`}&nbsp;&nbsp; Max Size: 12MB</span>
        </div>
    );
};

export default PhotosSpecifications;
